export type TMapItemType =
  | 'main'
  | 'cafe'
  /** Поликлиники **/
  | 'clinic'
  /** Продуктовые магазины **/
  | 'grocery'
  /** Метро **/
  | 'metro'
  /** Детские сады **/
  | 'nursery'
  /** Школы **/
  | 'school';

export interface IInfrastructureItem {
  /** Координаты пина на карте **/
  coordinates: IInfrastructureItemCoordinates;
  /** id **/
  id: string;
  /** Время пешком до объекта **/
  timeWalk: number;
  /** Название объекта **/
  title: string;
  /** Тип объекта инфраструктуры **/
  type: TMapItemType;
}

export enum EPanoramaState {
  Loaded,
  None,
}

export interface IInfrastructureItemCoordinates {
  /** Широта **/
  lat: number;
  /** Долгота **/
  lng: number;
}
